import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiErr } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const token = localStorage.getItem("jd_token");
    if (!token) { setUser(false); setReady(true); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("jd_token");
      setUser(false);
    }
    setReady(true);
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("jd_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("jd_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const googleSession = async (session_id) => {
    const { data } = await api.post("/auth/google/session", { session_id });
    localStorage.setItem("jd_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const loginWithToken = async (token) => {
    localStorage.setItem("jd_token", token);
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("jd_token");
    setUser(false);
  };
  const refreshUser = load;

  return (
    <AuthContext.Provider value={{ user, ready, login, register, googleSession, loginWithToken, logout, refreshUser, setUser, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

const STAFF = ["super_admin", "admin", "project_manager", "developer", "support"];
export const isStaff = (u) => u && STAFF.includes(u.role);
